import React, { Suspense } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Provider } from 'mobx-react';
import themes, { overrides } from '../themes';
import Layout from './Layout';
import Error from '../pages/error';
import Login from '../pages/login';
import Qrcode from '../pages/qrcode';
import RegisterGarminAccount from '../pages/register/registerGarminAccount';
import Localization from '../pages/localization/LocalizationPage';
// import SummaryReportPage from '../pages/summaryReport/SummaryReportPage'
import allStores from '../store/AllStore';
import RequestReset from '../pages/resetPassword/requestReset';
import ResetPassword from '../pages/resetPassword/resetPassword';

// import resolveConfig from 'tailwindcss/resolveConfig';
// import tailwindConfigModule from "../tailwind.config.js";

// const tailwindConfig = resolveConfig(tailwindConfigModule);

const theme = createMuiTheme({
  ...themes.default,
  ...overrides,
  typography: {
    fontFamily: ['Kanit', 'sans-serif'].join(','),
    useNextVariants: true,
  },
});
window.soundManager.setup({ debugMode: false });

const PrivateRoute = ({ component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        localStorage.getItem('id_token') ? (
          React.createElement(component, props)
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const PublicRoute = ({ component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        localStorage.getItem('id_token') ? (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        ) : (
          React.createElement(component, props)
        )
      }
    />
  );
};
const Loader = () => (
  <div className='App'>
    <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '20px' }}>loading...</div>
  </div>
);

const App = () => (
  <Suspense fallback={<Loader />}>
    <MuiThemeProvider theme={theme}>
      <Provider {...allStores}>
        <BrowserRouter>
          <Switch>
            <Route exact path='/' render={() => <Redirect to='/app/dashboard' />} />
            <Route exact path='/app' render={() => <Redirect to='/app/dashboard' />} />
            <Route exact path='/qrcode/:bedId/:status' component={Qrcode} />
            <Route exact path='/localization' component={Localization} />
            <Route
              exact
              path='/smartwatch/create/:patientId/:username/:pathname/:tenantId'
              component={RegisterGarminAccount}
            />
            <Route exact path='/smartwatch/update/:accountId/:username/:pathname' component={RegisterGarminAccount} />
            {/* <Route exact path="/app/summary/report/:id" component={SummaryReportPage} /> */}
            <PrivateRoute path='/app' component={Layout} />
            <PublicRoute path='/login' component={Login} />
            <PublicRoute path='/forgotpassword' component={RequestReset} />
            <PublicRoute path='/resetpassword/:token' component={ResetPassword} />


            <Route component={Error} />
          </Switch>
        </BrowserRouter>
      </Provider>
    </MuiThemeProvider>
  </Suspense>
);

export default App;
